import { get } from 'lodash';

class SeatStatus {
  constructor() {
    this.statusMap = {
      id: 'Id',
      status_code: 'StatusCode',
      description: 'Description',
      fore_color: 'ForeColor',
      back_color: 'BackColor',
      status_priority: 'StatusPriority',
      status_legend: 'StatusLegend'
    };
  }

  map(statuses) {
    let theSstatuses = [];
    for (let x = 0; x < statuses.length; x++) {
      let status = {};
      for (let p in this.statusMap) {
        status[p] = get(statuses[x], this.statusMap[p]);
      }
      theSstatuses.push(status);
    }

    return theSstatuses;
  }
}

export default SeatStatus;



// WEBPACK FOOTER //
// ./src/javascripts/lib/tessitura/REST/maps/SeatStatus.js